import { render, staticRenderFns } from "./PatientClaimList.vue?vue&type=template&id=c6b2f13c&scoped=true&"
import script from "./PatientClaimList.vue?vue&type=script&lang=js&"
export * from "./PatientClaimList.vue?vue&type=script&lang=js&"
import style0 from "./PatientClaimList.vue?vue&type=style&index=0&id=c6b2f13c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b2f13c",
  null
  
)

export default component.exports